<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'App',
};
</script>

<style>
	#app {
		font-family: Candara, Helvetica, Arial, sans-serif;
	}
	body {
		background-color: #000;
		color: white;
		position: relative;
	}
</style>
